<template>
  <button
    ref="menuToggle"
    class="menu-toggle"
    @click="handleToggle($event)"
  >
    <i class="menu-toggle__icon" />
    <span
      v-if="open"
      class="hidden-text"
    >Toggle main menu closed</span>
    <span
      v-else
      class="hidden-text"
    >Toggle main menu open</span>
  </button>
</template>

<script>
import bus from './../bus';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

export default {
  props: {},
  data() {
    return {
      open: false,
      closeButton: null,
    };
  },
  mounted() {
    this.addCloseButton();
  },
  methods: {
    addCloseButton() {
      let element = document.getElementById('app');
      this.closeButton = document.createElement('button');
      this.closeButton.className = 'menu-toggle__close';
      this.closeButton.addEventListener('click', this.closeMenu, false);
      this.closeButton.addEventListener('touchstart', this.closeMenu, false);
      element.appendChild(this.closeButton);
    },
    closeMenu() {
      this.open = false;
      document
        .querySelector('body')
        .removeEventListener('click', this.handleClick, false);
      document
        .querySelector('body')
        .removeEventListener('touchstart', this.handleClick, false);
      setTimeout(() => {
        // Delay long enough to prevent iOS Safari from firing tap event on underlying elements
        document.querySelector('body').classList.remove('open-sidebar-menu');
      }, 100);

      bus.$emit('sidebarOpen', false);
    },
    openMenu() {
      this.open = true;
      document.querySelector('body').classList.add('open-sidebar-menu');
      document
        .querySelector('body')
        .addEventListener('click', this.handleClick, false);
      document
        .querySelector('body')
        .addEventListener('touchstart', this.handleClick, false);

      bus.$emit('sidebarOpen', true);
      enableBodyScroll(document.body);
    },
    handleToggle(event) {
      event.stopPropagation();
      if (
        document.querySelector('body').classList.contains('open-sidebar-menu')
      ) {
        this.closeMenu();
        enableBodyScroll(document.body);
      } else {
        this.openMenu();
        disableBodyScroll(document.body);
        clearAllBodyScrollLocks(document.body);
      }
    },

    handleClick(event) {
      if (
        document.getElementsByClassName('sidebar')[0].contains(event.target)
      ) {
        return;
      }

      if (this.open) {
        this.closeMenu();
      }
    },
  },
};
</script>
